const chainProcess = (fns, data) => {
  let appliedData = data;

  for (const fn of fns) {
    appliedData = fn(appliedData);
  }

  return appliedData;
};

export const normalizeOnEachNode = (arr, normalizeOnEachNodeFns) => {
  if (arr instanceof Array) {
    arr = arr
      .map((item) => {
        if (item) {
          let newItem = chainProcess(normalizeOnEachNodeFns, item);
          if (newItem?.children) {
            newItem = { ...newItem };
            newItem.children = normalizeOnEachNode(newItem.children, normalizeOnEachNodeFns).filter(
              Boolean
            );
            if (newItem.children.length === 0) {
              return null;
            }
          }
          return newItem;
        }
        return item;
      })
      .filter(Boolean);
  }
  return chainProcess(normalizeOnEachNodeFns, arr);
};

export const normalizeEachNode = (normalizeOnEachNodeFns) => (arr) => {
  return normalizeOnEachNode(arr, normalizeOnEachNodeFns);
};
